/* globals */

import httpClient from './lib/httpClient'

export const sendEmail = async (payload) => {
  const endpoint = '/api/Email'
  return httpClient.post(endpoint, payload)
}

export default {
  sendEmail
}
